module.exports = __webpack_public_path__ + "img/10.473395e5.png";